"use client"

import { useState } from "react"
import { Link } from "react-router-dom"

import "./Navbar.css"

const Navbar = ({ language, setLanguage }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const translations = {
    en: {
      brand: "BICHI FIRST",
      home: "Home",
      about: "About AKA",
      awards: "Awards",
      projects: "Constituency Projects",
      legislative: "Legislative Work",
      gallery: "Gallery",
      polling: "Polling Units",
      faq: "FAQ",
      contact: "Contact",
    },
    ha: {
      brand: "BICHI FARKO",
      home: "Gida",
      about: "Game da AKA",
      awards: "Kyaututtuka",
      projects: "Ayyukan Mazaba",
      legislative: "Aikin Majalisa",
      gallery: "Hotunan Ayyuka",
      polling: "Wuraren Zabe",
      faq: "Tambayoyi",
      contact: "Tuntuɓar Mu",
    },
  }

  const t = translations[language]

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setMobileMenuOpen(false)
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand" style={{ display: 'flex', alignItems: 'center', fontSize: '1.1rem', whiteSpace: 'nowrap' }}>
          <span style={{ fontSize: '1.05em', marginRight: '0.25em' }}>{t.brand}</span>
          <span className="checkmark" style={{ marginLeft: '0.1em', fontSize: '1em' }}>✓</span>
        </Link>

        <ul className="navbar-nav">
          <li><Link to="/">{t.home}</Link></li>
          <li><Link to="/about">{t.about}</Link></li>
          <li><Link to="/awards">{t.awards}</Link></li>
          <li><Link to="/projects">{t.projects}</Link></li>
          <li><Link to="/legislative">{t.legislative}</Link></li>
          <li><Link to="/gallery">{t.gallery}</Link></li>
          <li><Link to="/polling">{t.polling}</Link></li>
          <li><Link to="/faq">{t.faq}</Link></li>
          <li><Link to="/contact">{t.contact}</Link></li>
          <li>
            <select
              className="language-select"
              value={language}
              onChange={e => setLanguage(e.target.value)}
              style={{ padding: '0.3em 0.7em', borderRadius: '6px', border: '1px solid #1a5f3f', marginLeft: '0.5em', fontSize: '1em' }}
            >
              <option value="en">English</option>
              <option value="ha">Hausa</option>
            </select>
          </li>
        </ul>

        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? "✕" : "☰"}
        </button>

        <div className={`mobile-menu ${mobileMenuOpen ? "active" : ""}`}>
          <ul>
            <li><Link to="/" onClick={closeMobileMenu}>{t.home}</Link></li>
            <li><Link to="/about" onClick={closeMobileMenu}>{t.about}</Link></li>
            <li><Link to="/awards" onClick={closeMobileMenu}>{t.awards}</Link></li>
            <li><Link to="/projects" onClick={closeMobileMenu}>{t.projects}</Link></li>
            <li><Link to="/legislative" onClick={closeMobileMenu}>{t.legislative}</Link></li>
            <li><Link to="/gallery" onClick={closeMobileMenu}>{t.gallery}</Link></li>
            <li><Link to="/polling" onClick={closeMobileMenu}>{t.polling}</Link></li>
            <li><Link to="/faq" onClick={closeMobileMenu}>{t.faq}</Link></li>
            <li><Link to="/contact" onClick={closeMobileMenu}>{t.contact}</Link></li>
            <li>
              <select
                className="language-select"
                value={language}
                onChange={e => setLanguage(e.target.value)}
                style={{ padding: '0.3em 0.7em', borderRadius: '6px', border: '1px solid #1a5f3f', marginLeft: '0.5em', fontSize: '1em' }}
              >
                <option value="en">English</option>
                <option value="ha">Hausa</option>
              </select>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
// ...existing code...
}

export default Navbar
